import { Action } from "../../../types/state/action";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type MyApprovalsState = {
  limit: number;
  lastDays: number;
  requestor: string;
  context: number[];
  status: string[];
  search: string;
  hasFilterApplied: boolean;
  offset: number;
  dataResults: ValueOrNull<any>;
};

export enum MyApprovalRequestTypes {
  SET_LIMIT = "myApprovals/setLimit",
  SET_LAST_DAYS = "myApprovals/setLastDays",
  SET_REQUESTOR = "myApprovals/setRequestor",
  SET_CONTEXT = "myApprovals/setContext",
  SET_STATUS = "myApprovals/setStatus",
  SET_SEARCH = "myApprovals/setSearch",
  SET_FILTER_APPLIED = "myApprovals/setFilterApplied",
  SET_OFFSET = "myApprovals/setOffset",
  SET_DATA_RESULTS = "myApprovals/setDataResults"
}

export type MyApprovalRequestType = Action<
  MyApprovalRequestTypes,
  Partial<MyApprovalsState>
>;
